import React, { useState, useCallback } from 'react';
import styled from '@emotion/styled';

import InputInner from '~/theseus/components/Form/Input';
import InputLengthInner from '~/theseus/components/Form/InputWithLengthWarnings';
import withError from '~/theseus/components/Form/withError';

import BaseField from '../Field';
import Header from '../Header';
import Section from '../Section';
import Description from '../Description';

import Preview from './Preview';

const Field = styled(BaseField)`
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  
  .label {
    margin-bottom: 5px;
    font-size: 1.1em;
  }

  .error {
    margin-left: unset;
  }
`;

const Container = styled.div`
 display: flex;
 flex-direction: row; 
 align-items: center;
`;

const FieldContainer = styled.div`
  margin-left: 20px;
  flex-grow: 2;
`;

const Input = withError(InputInner);
const InputWithLengthWarnings = styled(withError(InputLengthInner))`
  flex-grow: 2;
`;

function CallingCard({ register, errors, control }) {
  const [currentlyFocused, setCurrentlyFocused] = useState(null);

  const changeFocused = useCallback(e => setCurrentlyFocused(e.target.id), []);

  const resetFocused = useCallback(() => setCurrentlyFocused(null), []);

  return (
    <Section aria-labelledby="calling-card-label">
      <Header css={{ border: 'none' }}>
        <h2 id="calling-card-label">Create Website Message</h2>
      </Header>
      <Description role="tooltip">
        You can customize the screen your leads see after they submit the form
      </Description>
      <Container>
        <FieldContainer>
          <Field htmlFor="headline-message">
            <span className="label">Headline</span>
            <InputWithLengthWarnings
              id="headline-message"
              name="callingCard.headline"
              ref={register({ required: 'Headline is required' })}
              type="text"
              maxLength={60}
              placeholder="Required"
              error={errors.callingCard && errors.callingCard.headline}
              onFocus={changeFocused}
              onBlur={resetFocused}
            />
          </Field>
          <Field htmlFor="description">
            <span className="label">Description</span>
            <Input
              id="description"
              as="textarea"
              ref={register({ required: 'Description is required' })}
              name="callingCard.description"
              placeholder="Required"
              error={errors.callingCard && errors.callingCard.description}
              onFocus={changeFocused}
              onBlur={resetFocused}
            />
          </Field>
          <Field htmlFor="button-text">
            <span className="label">Button Text</span>
            <InputWithLengthWarnings
              id="button-text"
              name="callingCard.buttonText"
              ref={register({ required: 'Button text is required' })}
              type="text"
              maxLength={30}
              placeholder="Required"
              error={errors.callingCard && errors.callingCard.buttonText}
              onFocus={changeFocused}
              onBlur={resetFocused}
            />
          </Field>
        </FieldContainer>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <h2 style={{ fontWeight: 500, fontSize: '1.3em' }}>Preview</h2>
          <Preview control={control} currentlyEditing={currentlyFocused} />
        </div>
      </Container>
    </Section>
  );
}

export default React.memo(CallingCard);
